"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get generateTempFilePath () {
        return generateTempFilePath;
    },
    get waitForStreamClose () {
        return waitForStreamClose;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _os = /*#__PURE__*/ _interop_require_default(require("os"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function generateTempFilePath() {
    return _path.default.join(_os.default.tmpdir(), 'temp.txt');
}
async function waitForStreamClose(stream) {
    return new Promise((resolve, reject)=>{
        stream.once('finish', ()=>{
            resolve();
        }).once('error', (err)=>{
            reject(err);
        });
        stream.end();
    });
}
